// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604291203/js/" + chunkId + "." + {"44":"ffb047c3","225":"df290693","481":"a2c15e04","486":"5cee9b4a","770":"ce4abf0a"}[chunkId] + ".0.8333666391739762.chunk.js";
};